export default __webpack_public_path__ + "static/media/Menu_Icon_Decisions.28899d29.svg";